import classes from './WelcomeName.module.css'

interface IWelcomeNameProps{
    name: string
}

const WelcomeName: React.FC<IWelcomeNameProps> = ({name})=>{

    return(
    <div className='row mx-0 justify-content-center'>
    <div className='col px-0' style={{
        display: 'flex', 
        flexDirection: 'row', 
        alignItems: 'center', 
        justifyContent: 'flex-end'}}
    >
        <h2 className={[classes.ptitle, classes.white].join(' ')}>{name}</h2>
        <h2 className={[classes.ptitle, classes.white].join(' ')}>مرحباً بك يا  </h2>
     </div>
     </div>
    )
} 


export default WelcomeName